<template>
    <div v-show="isModalOpen" class="modal-overlay">
        <div class="my-modal">
            <!-- Заголовок -->
            <div class="modal-header">
                <h3>Поиск программ</h3>
                <button class="close-btn" @click="closeModal">✖</button>
            </div>

            <div class="search_content">
                <input
                    type="text"
                    v-model="searchText"
                    placeholder="Введите запрос..."
                    class="search_content__input"
                />
                <button class="search_content__button" @click="searchProgramByText">Поиск</button>
            </div>
            <p class="favtt">Добавить в избранное</p>
            <button
                v-if="checkedFavourites.length > 0"
                @click="addToFavourites"
                class="add-btn"
                :disabled="savingFavourites"
            >
                {{ savingFavourites ? 'Сохранение…' : 'Добавить выбранные в избранное' }}
            </button>
            <div class="results">
                <div v-if="searchLoading" class="results__skeleton">
                    <div v-for="n in 3" :key="n" class="sk sk--card" />
                </div>
                <p v-else-if="filteredResults.length === 0">Ничего не найдено</p>
                <div v-else class="results__content">
                    <div class="results__content__blocks" v-for="item in filteredResults">
                        <swiper class="results__content__blocks__left"
                                :slidesPerView="1"
                                :speed="1000"
                                :autoplay="true"
                                :pagination="{
                                    clickable: true,
                                }"
                                :lazy="true"
                                :loop="true">
                            <swiper-slide
                                v-for="(img) in item?.images"
                                :key="img"
                                class="results__content__blocks__left__swiper_slide"
                            >
                                <img :src="img.image" />
                            </swiper-slide>
                        </swiper>
                        <div class="results__content__blocks__right">
                            <p class="results__content__blocks__right__topText">{{ item?.university }}</p>
                            <p class="results__content__blocks__right__title">{{ item?.programName }}</p>
                            <div class="line"></div>
                            <div class="results__content__blocks__right__rate">
                                <p v-if="item?.top">{{ item?.top }}</p>
                                <span v-if="item?.subcategory?.category?.title">{{ item?.subcategory?.category?.title }}</span>
                            </div>
                            <div class="results__content__blocks__right__buttons">
                                <label class="checkbox-label">
                                    <input
                                        type="checkbox"
                                        :value="item.id"
                                        v-model="checkedFavourites"
                                        style="display: none"
                                    />
                                    <span :class="['custom-checkbox', { checked: checkedFavourites.includes(item.id) }]"></span>
                                    В избранное
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination } from 'swiper';
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination, A11y, Autoplay])
import axios from "axios";
import {toast} from "vue3-toastify";

export default {
    name: "ModalSearch",
    components: {Swiper, SwiperSlide},
    data() {
        return {
            isModalOpen: false, // управление показом
            searchText: "", // текст поиска
            programs: [],
            checkedFavourites: [],
            searchLoading: false,
            savingFavourites: false,
        };
    },
    computed: {
        filteredResults() {
            return this.programs;
        },
    },
    methods: {
        searchProgramByText(){
            const data = {
                text: this.searchText
            };
            this.searchLoading = true;
            axios.post(`platform/expert/favourites/search`, data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                this.programs = response.data.data;
            })
            .catch((error) => {
                toast.error(error.response?.data?.errors || "Произошла ошибка");
            })
            .finally(() => {
                this.searchLoading = false;
            });
        },
        openModal() {
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
            if(this.checkedFavourites.length > 0){
                location.reload()
            }
        },
        async addToFavourites(){
            this.savingFavourites = true;
            const data = {
                program_ids: this.checkedFavourites,
                user_id: this.$route.params.id
            }
            await axios.post('/platform/expert/favourites/addByExpert', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if(response.status === 200) {
                    toast.success('Успешно добавлено');
                }else{
                    toast.error('Произошла ошибка');
                }
            })
            .catch((error) => {
                toast.error(error.response?.data?.errors || "Произошла ошибка");
            })
            .finally(() => {
                this.savingFavourites = false;
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.results {
    &__skeleton {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 12px 0;
    }
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.favtt{
    display: block;
    margin: 15px 0;
    font-size: 20px;
    font-weight: 700;
}
.my-modal {
    position: fixed;
    top: 50px;
    z-index: 1055;
    display: block;
    min-width: 300px;
    max-width: 1000px;
    width: 1000px;
    height: fit-content;
    background: #fff;
    padding: 60px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.close-btn {
    border: none;
    background: none;
    font-size: 18px;
    cursor: pointer;
}
.swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
    background: #000000a3;
    bottom: 30px;
    width: fit-content;
    margin: 0 auto;
    border-radius: 10px;
}
.results{
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;

    &__content{
        display: flex;
        overflow-y: auto;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        height: 400px;

        &__blocks{
            display: flex;
            width: 50%;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;
            margin:0 0 25px;
            padding: 0 0 25px;
            border-bottom: 1px solid #ccc;

            &__left{
                display: block;
                width: 30%;
                &__swiper_slide img{
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                    -o-object-fit: cover;
                    object-fit: cover;
                    height: 100%;
                }
            }

            &__right{
                display: block;
                width: 70%;
                padding: 0 15px;

                &__topText{
                    display: block;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.5411764706);
                }

                &__title{
                    display: block;
                    font-weight: 700;
                    font-size: 20px;
                }

                &__rate{
                    font-weight: 700;
                    color: #FD2D2A;
                    display: flex;
                    gap: 10px;
                    align-items: center;

                    span {
                        color: #11415D !important;
                    }
                }
                &__buttons{
                    display: block;
                    margin: 15px 0 0;
                }
            }
        }
    }
}
.line{
    display: block;
    border-top: 1px solid rgba(0, 0, 0, 0.1019607843);
    width: 100%;
    margin: 15px 0;
}
.search_content{
    display: flex;
    width: 100%;
    margin: 15px 0;
    flex-direction: row;
    justify-content: space-between;

    &__input{
        width: calc(100% - 110px);
        margin: 0;
        padding: 8px;
        border: 1px solid #ddd;
        border-radius: 6px;
    }

    &__button{
        display: block;
        width: 100px;
        padding: 0 8px;
        border: 1px solid #00A1FF;
        border-radius: 6px;
        background: #00A1FF;
        color: #fff;
    }
}

.program-item {
    margin: 10px 0;
}

.checkbox-label {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
}

.custom-checkbox {
    width: 20px;
    height: 20px;
    border: 2px solid gray;
    border-radius: 4px;
    display: inline-block;
    margin-right: 10px;
    transition: all 0.3s;
}

.custom-checkbox.checked {
    background-color: green;
    border-color: green;
}

.add-btn {
    padding: 10px 15px;
    background: green;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    margin: 0 0 30px;
    transition: 0.3s all;
}
</style>
